export const PROGRESS_BAR_DEFAULT_VALUE = 0
